(function () {
  /**
   * The JavaScript code you place here will be processed by esbuild, and the
   * output file will be created at `../javascript/script.min.js` and enqueued in
   * `../functions.php`.
   *
   * For esbuild documentation, please see:
   * https://esbuild.github.io/
   */

  document.addEventListener("DOMContentLoaded", function () {
    // force value og:locale
    let meta = document.querySelector('meta[property="og:locale"]');
    if (meta) {
      meta.setAttribute("content", "fr_BE");
    }
  });

  // lazy loading for background images
  let lazyloadThrottleTimeout;

  function lazyload(lazyloadImages) {
    if (lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }

    lazyloadThrottleTimeout = setTimeout(function () {
      const scrollTop = window.scrollY;
      lazyloadImages.forEach(function (img) {
        // console.log("img", img);
        if (img.offsetTop < window.innerHeight + scrollTop) {
          img.src = img.dataset.src;
          img.classList.remove("lazy");
        }
      });
      if (lazyloadImages.length === 0) {
        document.removeEventListener("scroll", () => lazyload(lazyloadImages));
        window.removeEventListener("resize", () => lazyload(lazyloadImages));
        window.removeEventListener("orientationChange", () => lazyload(lazyloadImages));
      }
    }, 20);
  }

  document.addEventListener("DOMContentLoaded", function () {
    const lazyloadImages = document.querySelectorAll(".lazy");
    // console.log("lazyloadImages", lazyloadImages);
    if ("IntersectionObserver" in window) {
      const imageObserver = new IntersectionObserver(function (entries, observer) {
        // console.log("imageObserver", imageObserver);
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // console.log("entry", entry);
            const image = entry.target;
            image.classList.remove("lazy");
            observer.unobserve(image);
          }
        });
      });

      lazyloadImages.forEach(function (image) {
        imageObserver.observe(image);
      });
    } else {
      document.addEventListener("scroll", () => lazyload(lazyloadImages));
      window.addEventListener("resize", () => lazyload(lazyloadImages));
      window.addEventListener("orientationChange", () => lazyload(lazyloadImages));
    }

    const copyUrlButtons = document.querySelectorAll("button.ci-Modal-button-copy-url");
    if (copyUrlButtons) {
      copyUrlButtons.forEach(function (element) {
        const copyUrlField = document.querySelector("#" + element.id.replace("button-", ""));
        if (copyUrlField) {
          element.addEventListener("click", function () {
            // Select the text field
            copyUrlField.select();
            copyUrlField.setSelectionRange(0, 99999); // For mobile devices

            if (typeof navigator.clipboard !== "undefined") {
              // Copy the text inside the text field
              navigator.clipboard.writeText(copyUrlField.value);
            }

            // Alert the copied text
            console.log("Copied the text: " + copyUrlField.value);
          });
        }
      });
    }

    const golbalModalFacebookShare = document.querySelector("#global-modal-facebook-share");
    if (golbalModalFacebookShare) {
      golbalModalFacebookShare.addEventListener("click", function () {
        window.open(
          "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href,
          "facebook-share-dialog",
          "width=626, height=436",
        );
      });
    }
    const golbalModalTwitterkShare = document.querySelector("#global-modal-twitter-share");
    if (golbalModalTwitterkShare) {
      golbalModalTwitterkShare.addEventListener("click", function () {
        window.open("https://twitter.com/intent/tweet?url=" + window.location.href);
      });
    }
    const golbalModalLinkedinkShare = document.querySelector("#global-modal-linkedin-share");
    if (golbalModalLinkedinkShare) {
      golbalModalLinkedinkShare.addEventListener("click", function () {
        window.open(
          "https://www.linkedin.com/shareArticle?mini=true&url=" +
            encodeURIComponent(window.location.href) +
            "&source=" +
            encodeURIComponent(window.location.href),
        );
      });
    }
    const golbalModalPrintButton = document.querySelector("#global-modal-print-button");
    if (golbalModalPrintButton) {
      golbalModalPrintButton.addEventListener("click", function () {
        document.querySelector(".ci-Modal--small").classList.remove("is-open");
        document.querySelector("html").classList.remove("no-scroll");
        setTimeout(function () {
          window.print();
        }, 600);
      });
    }
  });
})();
